import React from 'react';
import { Outlet,Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";

const PrivateRoute = () => {
    const authentication = useSelector(
        state => state.auth.accessToken.token
    );
     return authentication!==''? <Outlet /> : <Navigate to="Login" />;
}

export default PrivateRoute
